<template>
  <v-dialog v-model="dialogModel" v-bind="dialog" @click:outside="close(page)" @keydown.esc="close(page)">
    <v-card v-bind="card">
      <v-app-bar v-bind="toolbar">
        <v-toolbar-title :class="toolbar.class">{{ toolbar.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <i4proActions
          v-if="actionsToolbar"
          :page="page"
          :mode="componentParams.context"
          :origin="componentParams.origin"
          :tag="'v-toolbar-items'"
          :isValid="isValid"
          :tab="tab"
          :step="step"
        />
        <v-icon class="ml-2" dark @click="close(page)">close</v-icon>
      </v-app-bar>

      <v-container v-bind="containerConfig" :class="['form-dialog', 'px-1', 'pt-3', toolbar.fixed && 'margin-fixed']">
        <component
          :is="currentComponent"
          :page="page"
          v-bind="componentParams"
          :renderActions="!this.actionsToolbar"
          @change-tab="changeTab"
          @change-step="changeStep"
          @validate-dialog="validateDialog"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import { sleep } from '@/helpers/page';
import store from '@/store';

export default {
  components: {
    i4proForm: () => import('@/components/layouts/i4pro-form'),
    i4proList: () => import('@/components/layouts/i4pro-list'),
    i4proTable: () => import('@/components/tables/i4pro-table'),
    i4proActions: () => import('@/components/partials/i4pro-actions')
  },

  props: {
    page: { type: String, required: true },
    currentComponent: { type: String, required: true },
    componentParams: { type: Object, required: true },
    actionsToolbar: { type: Boolean, default: false },
    dialog: { type: Object },
    toolbar: { type: Object },
    card: { type: Object }
  },

  data: () => ({
    dialogModel: false,
    tab: 0,
    step: 0,
    isValid: false
  }),

  events: {
    [HANDLERS.CLOSE_DIALOG]: 'close'
  },

  mounted() {
    this.dialogModel = true;
  },

  computed: {
    containerConfig: () => store.getters['layout/getConfigLayout'].container
  },

  methods: {
    validateDialog(valid) {
      this.isValid = valid;

      if (!valid) {
        store.dispatch('notification/showNotification', {
          color: 'error',
          text: 'Existem campos obrigatórios não preenchidos',
          showIconNotification: false
        });
      }
    },

    async close(page) {
      if (this.page !== page) return;
      this.dialogModel = false;
      await sleep(300);
      this.$emit('close', this.id);
    },

    changeTab(newValue) {
      this.tab = newValue;
    },

    changeStep(newValue) {
      this.step = newValue;
    }
  }
};
</script>

<style lang="scss">
.form-dialog {
  .layout.row {
    &:only-child {
      margin: 0;
    }
  }
}

.margin-fixed {
  padding-top: 60px;
}
</style>
